import { render, staticRenderFns } from "./Risks.vue?vue&type=template&id=7f04f950&scoped=true"
import script from "./Risks.vue?vue&type=script&lang=js"
export * from "./Risks.vue?vue&type=script&lang=js"
import style0 from "./Risks.vue?vue&type=style&index=0&id=7f04f950&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f04f950",
  null
  
)

export default component.exports